(function () {
    'use strict';

    angular
        .module('szallodak-partner', []);
})();
